"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var minLength = function (minLengthValue) { return function (value) {
    if (value && value.length > 0) {
        return value.length < minLengthValue
            ? "The input has less characters than " + minLengthValue
            : undefined;
    }
    return undefined;
}; };
exports.default = (function (minValue, err) { return withCustomError_1.default(minLength(minValue))(err); });
//# sourceMappingURL=minLength.js.map